'use client';
import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import Image from 'next/image';
import lady from './assets/lady.png';
import ladyGroup from './assets/lady-group.png';
import man from './assets/man.png';
import manGroup from './assets/man-group.png';
import linkedin from './assets/linkedin.png';
import sap from './assets/sap.png';

export function AnimatedHeroImageGroup() {
  const groupRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const images = gsap.utils.toArray('.slide') as HTMLImageElement[];
      const tl = gsap.timeline({ repeat: -1 });
      images.forEach(image => tl.add(fadeIn(image)));
    },
    { scope: groupRef },
  );

  return (
    <div
      ref={groupRef}
      className="stack relative col-span-12 col-start-auto mx-auto h-full w-[18.75rem] overflow-clip md:w-[37.5rem] md:overflow-x-visible lg:col-span-6 lg:col-start-7"
    >
      <div className="slide h-full max-h-[50rem] self-center opacity-0 lg:self-end xl:-mr-80 xl:h-3/4 xl:max-h-full">
        <Image
          src={lady}
          alt="A smiling Chief Technology Officer"
          className="h-auto object-contain"
          fill={true}
          priority
        />
        <Image
          src={ladyGroup}
          alt=""
          className="absolute right-12 top-12 hidden object-contain md:block md:h-[7.5rem] lg:right-0 lg:top-[6.25rem] lg:h-auto"
          height={224}
          width={200}
        />
        <div className="text-body absolute right-[10.9375rem] top-[12.5rem] hidden w-fit rounded-4xl bg-white px-[1.25rem] py-[0.625rem] text-gradle-green md:block lg:-right-14 lg:top-[20.625rem]">
          Chief Technology Officer, <span className="text-gray-1">750 seats</span>
        </div>
      </div>
      <Image
        src={linkedin}
        alt="Linkedin, We save more than 800 hours every day in CI and local builds"
        className="slide place-self-center opacity-0"
        height={466}
        width={460}
      />
      <div className="slide -mb-[55px] h-full max-h-[50rem] self-center opacity-0 lg:self-end xl:-mr-80 xl:h-3/4 xl:max-h-full">
        <Image src={man} alt="A smiling Chief Technology Officer" className="h-auto object-contain" fill={true} />
        <Image
          src={manGroup}
          alt=""
          className="absolute right-12 top-12 hidden object-contain md:block md:h-[7.5rem] lg:-right-2 lg:top-[2.1875rem] lg:h-auto"
          height={224}
          width={200}
        />
        <div className="text-body absolute right-[10.9375rem] top-[12.5rem] hidden w-fit rounded-4xl bg-white px-[1.25rem] py-[0.625rem] text-gradle-green md:block lg:-right-14 lg:top-[17.5rem]">
          Engineering Manager, <span className="text-gray-1">178 seats</span>
        </div>
      </div>
      <Image
        src={sap}
        alt="SAP Conservatively, we've gained back 1 day of lost productivity every week."
        className="slide place-self-center opacity-0"
        height={466}
        width={460}
      />
    </div>
  );
}

function fadeIn(image: HTMLImageElement) {
  return gsap
    .timeline()
    .fromTo(image, { opacity: 0, x: 75, y: 0 }, { opacity: 1, x: 0, y: 0, duration: 2, ease: 'power2.in' })
    .to(image, { opacity: 0, duration: 1.5 }, '+=1.5');
}
